import { render, staticRenderFns } from "./AnnotationAudio.vue?vue&type=template&id=ce9c1b76"
import script from "./AnnotationAudio.vue?vue&type=script&lang=js"
export * from "./AnnotationAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports